import React from "react";
import { ProgressBar, Intent } from "@blueprintjs/core";
import { Icon } from "../../atoms/Icon";
import { useDropzone } from "react-dropzone";
import classNames from "classnames";
import styles from "./FileUploader.module.scss";

export default function FileUploader({
  title,
  accept,
  uploading,
  progress,
  onFileChange
}) {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept,
    onDrop: onFileChange
  });

  const isUploadComplete = uploading && progress === 1;

  return (
    <div
      className={classNames(styles.fileUploader, {
        [styles.dragActive]: isDragActive
      })}
      {...getRootProps()}
    >
      <input {...getInputProps()} />

      <Icon
        name={isUploadComplete ? "tick" : "upload"}
        color="#9fa9ba"
        size={50}
      />

      <p className={styles.title}>
        {isUploadComplete ? "Upload Complete!" : title}
      </p>

      {uploading && !isUploadComplete && (
        <ProgressBar
          className={styles.progressBar}
          value={progress}
          intent={Intent.PRIMARY}
        />
      )}
    </div>
  );
}
